// @flow
import React from 'react';
import useScheduledDeployment from '~/deploy/components/useScheduledDeployment';
import useDeploymentHistory from '~/deploy/components/useDeploymentHistory';
import usePendingDeployment from '~/deploy/components/usePendingDeployment';
import getNextVersion from '~/lib/getNextVersion';
import DeployModal from './DeployModal';

type Props = {
  pages: Array<{ title: string, path: string }>,
  selectedVersionIds: Array<string>,
  onDone: () => void,
  onCancel: () => void
};

/**
 * Redeploys the selected pages' live versions. Loads what it needs to suggest
 * the next version number only when opened, not with every page of the list.
 * Opens straight away: until the version is worked out, the dialog says so and
 * its Redeploy button waits.
 */
const RedeploySelected = ({ pages, selectedVersionIds, onDone, onCancel }: Props) => {
  const {
    activeDeployment,
    deploymentHistory,
    refetchDeploymentHistory
  } = useDeploymentHistory({ onlyVersions: true });
  const { scheduledDeployment } = useScheduledDeployment();
  const { refetchPendingDeployment } = usePendingDeployment();

  return (
    <DeployModal
      pages={pages}
      selectedVersionIds={selectedVersionIds}
      nextVersion={getNextVersion(activeDeployment, scheduledDeployment, deploymentHistory)}
      onCancel={onCancel}
      onDeploy={() => {
        refetchDeploymentHistory();
        refetchPendingDeployment();
        onDone();
      }}
    />
  );
};

export default RedeploySelected;
